module.exports = __webpack_public_path__ + "img/k25y-l6-j.prt.27012be0.jpg";